import Utils from '../../modules/utils'

const saveContact = (accountName, buyerName, existingAccount, userId, callbackFunc) => {
  const url = 'contacts'
  const data = {accountName, buyerName, existingAccount, userId}
  Utils.post(url, data, callbackFunc)
}

export {saveContact}
